'use strict';

module.exports = require('../src');


//////////////////
// WEBPACK FOOTER
// ./hysdk.js
// module id = 60
// module chunks = 2 4